import { useEffect } from 'react';
import '@/components/landing/landing.css';
import { FooterSection, Navbar } from '@/components/landing';
import { navigateToLanding } from '@/lib/navigateLanding';

interface ImpressumViewProps {
  onNavigateHome: () => void;
  onBlogClick?: () => void;
  onDatenschutzClick?: () => void;
}

export const ImpressumView: React.FC<ImpressumViewProps> = ({
  onNavigateHome,
  onBlogClick,
  onDatenschutzClick,
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const prev = document.title;
    document.title = 'Impressum — estage.ai';
    return () => { document.title = prev; };
  }, []);
  const handleNavigateHome = (sectionHash?: string) => navigateToLanding(onNavigateHome, sectionHash);

  return (
    <div className="landing-root">
      <Navbar onCtaClick={onNavigateHome} onLoginClick={onNavigateHome} onNavigateHome={handleNavigateHome} />

      {/* Content */}
      <div className="lp-legal-page">
        <div className="lp-legal-inner">
          <button onClick={onNavigateHome} className="lp-legal-back">← Zurück zur Startseite</button>
          <h1 className="lp-legal-title">Impressum</h1>
          <p className="lp-legal-updated">Angaben gemäß § 5 TMG / § 5 DDG sowie § 18 Abs. 2 MStV</p>

          <section className="lp-legal-section">
            <h2>Anbieter / Diensteanbieter</h2>
            <p>
              Mirey Advertising<br />
              Inhaber: Till Miosga<br />
              Thonberger Straße 3<br />
              04317 Leipzig<br />
              Deutschland
            </p>
          </section>

          <section className="lp-legal-section">
            <h2>Kontakt</h2>
            <p>
              Telefon: <a href="tel:+4917623300414">+49 (0) 176 23300414</a><br />
              E-Mail: <a href="mailto:info@estage.ai">info@estage.ai</a><br />
              Webseite: <a href="https://estage.ai" target="_blank" rel="noopener noreferrer">estage.ai</a>
            </p>
          </section>

          <section className="lp-legal-section">
            <h2>Umsatzsteuer-Identifikationsnummer</h2>
            <p>
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              <strong>DE326137093</strong>
            </p>
          </section>

          <section className="lp-legal-section">
            <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
            <p>
              Till Miosga<br />
              Thonberger Straße 3<br />
              04317 Leipzig
            </p>
          </section>

          <section className="lp-legal-section">
            <h2>EU-Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              . Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </section>

          <section className="lp-legal-section">
            <h2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section className="lp-legal-section">
            <h2>Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach
              den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter
              jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen
              oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
              allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch
              erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
              Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
              entfernen.
            </p>
          </section>

          <section className="lp-legal-section">
            <h2>Haftung für Links</h2>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
              Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
              Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
              Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf
              mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
              Verlinkung nicht erkennbar.
            </p>
            <p>
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
              Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechts­
              verletzungen werden wir derartige Links umgehend entfernen.
            </p>
          </section>

          <section className="lp-legal-section">
            <h2>Urheberrecht</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
              dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
              der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen
              Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind
              nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
            <p>
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die
              Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
              gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
              bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
              werden wir derartige Inhalte umgehend entfernen.
            </p>
          </section>

          <section className="lp-legal-section">
            <h2>Bildnachweise</h2>
            <p>
              Die auf dieser Website verwendeten Beispielbilder wurden entweder selbst erstellt,
              lizenziert oder mittels Künstlicher Intelligenz auf Grundlage von uns bzw. unseren
              Nutzern zur Verfügung gestellter Eingabebilder generiert.
            </p>
          </section>

          {onDatenschutzClick && (
            <section className="lp-legal-section">
              <p>
                Siehe auch:{' '}
                <a
                  href="/datenschutz"
                  onClick={(e) => { e.preventDefault(); onDatenschutzClick(); }}
                >
                  Datenschutzerklärung
                </a>
                .
              </p>
            </section>
          )}
        </div>
      </div>
      <FooterSection
        onNavigateHome={handleNavigateHome}
        onBlogClick={onBlogClick}
        onDatenschutzClick={onDatenschutzClick}
      />
    </div>
  );
};
